import { RouterModule, Routes } from '@angular/router';

import { BlockPages } from './../../models/pages.enum';
import { HomeComponent } from './containers/home/home.component';
import { NgModule } from '@angular/core';
import { SiteType } from '../../models/auth.model';

const routes: Routes = [
  {
    path: 'index',
    component: HomeComponent,
    data: { type: SiteType.ARSU, blockPage: BlockPages.HOME },
  },
  {
    path: 'discover',
    component: HomeComponent,
    data: { type: SiteType.ARSU, blockPage: BlockPages.DISCOVER },
  },
  {
    path: '**',
    redirectTo: 'index',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
